<template>
  <b-card header-tag="header" class="m-3" no-body>
    <template #header>
      <header-sagres titulo="Cadastro de Usuários" :botoes="botoesHeader" breakpoint="xl" />
    </template>
    <b-card-body>
      <CardFiltrosBusca>
        <b-form @submit.prevent="filtrarUsuarios" @reset.prevent="limparFiltros">
          <b-row>
            <b-col cols="12" sm="6" xl="3">
              <default-form-validation-provider label="Nome ou CPF" rules="" v-slot="defaultState">
                <b-form-input id="input-texto" v-model="filtros.texto" :state="defaultState.state" />
              </default-form-validation-provider>
            </b-col>
            <b-col cols="12" sm="6" xl="4">
              <default-form-validation-provider label="Situação">
                <b-form-radio-group v-model="filtros.situacao" :options="situacaoOptions" buttons
                  button-variant="light" />
              </default-form-validation-provider>
            </b-col>
            <b-col cols="12" xl="5">
              <default-form-validation-provider label="Unidade Gestora" v-slot="defaultState">
                <multiselect v-model="filtros.ug" open-direction="bottom" :close-on-select="true" :searchable="true"
                  :state="defaultState.state" deselect-label="" :allow-empty="true" placeholder="Selecione uma UG"
                  track-by="Codigo" :options="listaUGs" label="Nome" :show-labels="false"
                  class="wrapper-multiselect-sagres">
                  <template slot="noOptions">
                    <small><i>Erro ao obter dados.</i></small>
                  </template>
                  <template slot="noResult">
                    <i>Sem resultados.</i>
                  </template>
                </multiselect>
              </default-form-validation-provider>
            </b-col>
            <b-col cols="6" xl="3" offset-xl="3">
              <b-button type="reset" variant="outline-secondary">
                <font-awesome-icon icon="redo" class="mr-3" />
                Limpar
              </b-button>
            </b-col>
            <b-col cols="6" xl="3">
              <b-button type="submit" :disabled="tableBusy">
                <font-awesome-icon icon="search" class="mr-3" />
                Filtrar
              </b-button>
            </b-col>
          </b-row>
        </b-form>
      </CardFiltrosBusca>
      <b-table :fields="fields" :items="items" :busy="tableBusy" :current-page="currentPage" hover no-border-collapse
        sort-by="" :sort-desc="true" striped stacked="xl" show-empty>
        <template #empty>
          <span>Não foram encontrados dados.</span>
        </template>
        <template #emptyfiltered>
          <span>Não foram encontrados dados.</span>
        </template>
        <template #table-busy>
          <div class="text-center text-dark">
            <b-spinner class="align-middle"></b-spinner>
            <strong class="loading-text">Carregando...</strong>
          </div>
        </template>
        <template v-slot:cell(actions)="row">

          <b-dropdown class="d-md-none" right no-caret>
            <template #button-content>
              <font-awesome-icon icon="bars" />
            </template>
            <b-dropdown-item @click="detalhesUsuario(row.item)">
              <font-awesome-icon icon="eye" />
              <span>Detalhes</span>
            </b-dropdown-item>
            <b-dropdown-item v-if="['N', 'Não'].includes(row.item.INATIVO)" @click="editarUsuario(row.item)">
              <font-awesome-icon icon="edit" />
              <span>Editar</span>
            </b-dropdown-item>
            <b-dropdown-item @click="alertaResetRemove('Remover Perfil', row.item)">
              <font-awesome-icon icon="trash" />
              <span>Remover Perfis</span>
            </b-dropdown-item>
            <b-dropdown-item @click="alertaResetRemove('Resetar Senha', row.item)">
              <font-awesome-icon icon="trash" />
              <span>Resetar senha</span>
            </b-dropdown-item>
          </b-dropdown>
          <div class="actions-icons lgvert d-none d-md-flex justify-content-center">
            <b-link class="text-dark" @click="detalhesUsuario(row.item)">
              <font-awesome-icon icon="eye" />
              <div style="font-size: 12px">Detalhes</div>
            </b-link>
            <b-link v-if="['N', 'Não'].includes(row.item.INATIVO)" class="text-dark" @click="editarUsuario(row.item)">
              <font-awesome-icon icon="edit" />
              <div style="font-size: 12px">Editar</div>
            </b-link>
            <b-link class="text-dark" @click="alertaResetRemove('remover perfil', row.item)">
              <font-awesome-icon icon="ban" />
              <div style="font-size: 12px">Remover Perfis</div>
            </b-link>
            <b-link class="text-dark" @click="alertaResetRemove('resetar senha', row.item)">
              <font-awesome-icon icon="trash" />
              <div style="font-size: 12px">Resetar Senha</div>
            </b-link>
            <b-link v-if="!['N', 'Não'].includes(row.item.INATIVO)" class="text-dark" @click="alertaResetRemove('reativar', row.item)">
              <font-awesome-icon icon="check" />
              <div style="font-size: 12px">Reativar Usuário</div>
            </b-link>
          </div>
        </template>
      </b-table>
      <table-pagination v-if="totalRows" :total-rows="totalRows" :per-page="perPage" @pageChange="pageChange" />
    </b-card-body>
  </b-card>
</template>

<script lang="ts">
import TablePagination from "@/components/atos-pessoal/TablePagination.vue";
import CardFiltrosBusca from '@/components/shared/CardFiltrosBusca.vue';
import HeaderSagres from '@/components/shared/HeaderSagres.vue';
import usuarioService from "@/services/administracao/usuarioService";
import ugService from '@/services/administracao/ugService';
import { store } from "@/store";
import { fieldsConsultaUsuarios } from '@/types/administracao/usuarios/fields-usuarios';
import { FiltrosUsuarios } from '@/types/administracao/usuarios/filtros-usuarios';
import { BotaoSagres } from '@/types/botao-sagres';
import { SelectValue } from "@/types/select-value";
import { TableField } from '@/types/table-field';
import { UtilsTS } from '@/utilsts';
import { mixins } from 'vue-class-component';
import { Component, Vue } from 'vue-property-decorator';
import DefaultFormValidationProvider from "@/components/shared/DefaultFormValidationProvider.vue";
import { UnidadeGestoraResumida } from "@/types/ug/unidade-gestora-resumida";
import Multiselect from "vue-multiselect";
import { Usuario } from "@/types/administracao/usuarios/usuario";

const CompProps = Vue.extend({
  name: 'ConsultarUsuarios',
  components: { CardFiltrosBusca, DefaultFormValidationProvider, HeaderSagres, Multiselect, TablePagination }
})

@Component
export default class ConsultarUsuarios extends mixins(UtilsTS, CompProps) {
  fields: TableField[] = fieldsConsultaUsuarios
  items: Usuario[] = []
  filtros: FiltrosUsuarios = new FiltrosUsuarios()
  situacaoOptions: SelectValue[] = [
    { text: 'Todos', value: null },
    { text: 'Ativos', value: 'S' },
    { text: 'Inativos', value: 'N' }
  ]

  listaUGs: UnidadeGestoraResumida[] = []

  currentPage = 1
  perPage = 0
  totalRows = 0
  tableBusy = false

  botoesHeader: BotaoSagres[] = [
    {
      id: 1,
      icone: 'plus',
      texto: 'Novo Usuário',
      url: '/seguranca-administracao/usuarios/novo',
    },
  ]

  async mounted() {
    try {
      store.blockScreen = true
      await Promise.all([
        this.carregarUGs(),
        this.loadData()
      ])
    } catch (e) {
      console.error(e)
    } finally {
      store.blockScreen = false
    }
  }
  async pageChange(value: number) {
    this.currentPage = value;
    await this.loadData();
  }

  async loadData(): Promise<any> {
    try {
      this.tableBusy = true
      const response = await usuarioService.filtrarUsuarios(this.filtros, this.currentPage);
      if (!response) return this.$toast.error("Erro ao obter a lista de usuários");
      this.items = response.usuarios
      if (response.totalRows) this.totalRows = response.totalRows
      if (response.perPage) this.perPage = response.perPage
      if (response.currentPage) this.currentPage = response.currentPage
    } catch (e: any) {
      this.tratarError(e)
      this.items = []
      this.totalRows = 0
    } finally {
      this.tableBusy = false;
    }
  }

  alertaResetRemove(comand: string, usuario: Usuario) {
    this.$bvModal.msgBoxConfirm(`Deseja ${comand} ${this.capitalize(usuario.NOME)} ?`, {
      buttonSize: 'sm',
      cancelTitle: 'Cancelar',
      cancelVariant: 'outline-secondary',
      centered: true,
      headerBgVariant: 'secondary',
      headerTextVariant: 'light',
      okTitle: 'Confirmar',
      title: this.capitalize(comand),
    }).then(value => {
      if (value) switch (comand) {
        case 'remover perfil': this.removerPerfis(usuario); break;
        case 'resetar senha': this.resetarSenha(usuario); break;
        case 'reativar': this.reativarUsuario(usuario); break;
        default: break;
      }
    }).catch(err => {
      console.error(`Erro ao operar o dialog de alerta de ${comand}`, err)
    })
  }

  async detalhesUsuario(usuario: Usuario): Promise<void> {
    this.$router.push(`/seguranca-administracao/usuarios/${usuario.ID_USUARIO}`)
  }
  async editarUsuario(usuario: Usuario): Promise<void> {
    this.$router.push(`/seguranca-administracao/usuarios/${usuario.ID_USUARIO}/editar`)
  }
  async removerPerfis(usuario: Usuario): Promise<void> {
    try {
      let response = false
      if (usuario.ID_USUARIO) {
        const idUsuario = usuario.ID_USUARIO.toString()
        response = await usuarioService.removePerfil(idUsuario)
        if (response) {
          this.$toast.success(`Perfil removido com sucesso!`)
          this.$emit('refresh')
        } else if (usuario.NOME) {
          this.$toast.error(`Houve uma falha ao remover o(s) perfil(is) de ${this.capitalize(usuario.NOME)}.\nFavor atualizar a página e tentar novamente.`)
        }
      } else {
        this.$toast.error('Houve uma falha ao ler os dados deste usuário.\nFavor atualizar a página e tentar novamente.')
      }
    } catch (e: any) {
      this.tratarError(e)
    }
  }
  async resetarSenha(usuario: Usuario): Promise<void> {
    try {
      let response = false
      if (usuario.ID_USUARIO) {
        const idUsuario = usuario.ID_USUARIO.toString()
        response = await usuarioService.resetaSenha(idUsuario)
        if (response) {
          this.$toast.success(`Senha de ${this.capitalize(usuario.NOME)} resetada!`)
          this.$emit('refresh')
        } else if (usuario.NOME) {
          this.$toast.error(`Houve uma falha ao resetar a senha de ${this.capitalize(usuario.NOME)}.`)
        }
      }
    } catch (e: any) {
      this.tratarError(e)
      this.$toast.error('Houve uma falha ao ler os dados deste usuário.')
    }
  }

  async reativarUsuario(usuario: Usuario): Promise<void> {
    try {
      let response = false
      if (usuario.ID_USUARIO) {
        const idUsuario = usuario.ID_USUARIO.toString()
        response = await usuarioService.reativarUsuario(idUsuario)
        if (response) {
          this.$toast.success(`Usuário ${this.capitalize(usuario.NOME)} reativado!`)
          await this.filtrarUsuarios()
        } else if (usuario.NOME) {
          this.$toast.error(`Houve uma falha ao reativar usuário.`)
        }
      }
    } catch (e: any) {
      this.tratarError(e)
      this.$toast.error('Houve uma falha ao ler os dados deste usuário.')
    }
  }

  async limparFiltros() {
    this.filtros.limpar();
  }
  async filtrarUsuarios() {
    this.items = []
    this.totalRows = 0
    this.pageChange(1);
  }

  async carregarUGs() {
    try {
      this.listaUGs = await ugService.buscarUGsAtivas()
    } catch (e) {
      console.error(e)
    }
  }
};
</script>

<style scoped></style>